import { ExportRegisterMenuItem } from "./export-register-menu-item"
import { AssetRegistersContextMenu } from "../register-actions/register-actions.runtime"

AssetRegistersContextMenu.plug(<ExportRegisterMenuItem priority={30} />)
